import { presetRef, TEMPLATE_PRESETS, type UserTemplate } from "@lucralink/shared";
import { selectClassName } from "./controls";

interface TemplateRefSelectProps {
  readonly id: string;
  readonly value: string | null;
  readonly templates: readonly UserTemplate[];
  readonly onChange: (ref: string | null) => void;
  /** Rotulo da opcao vazia (ex.: "Usar o padrão global"). */
  readonly emptyLabel: string;
}

/** Seletor de template: modelos prontos + templates do usuario. */
export function TemplateRefSelect({
  id,
  value,
  templates,
  onChange,
  emptyLabel,
}: TemplateRefSelectProps): JSX.Element {
  return (
    <select
      id={id}
      className={selectClassName}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      <option value="">{emptyLabel}</option>
      <optgroup label="Modelos prontos">
        {TEMPLATE_PRESETS.map((preset) => (
          <option key={preset.key} value={presetRef(preset.key)}>
            {preset.name}
          </option>
        ))}
      </optgroup>
      {templates.length > 0 && (
        <optgroup label="Meus templates">
          {templates.map((template) => (
            <option key={template.id} value={template.id}>
              {template.name}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
